import React from "react";
import ErrorMessage from "../../../components/ErrorMessage/ErrorMessage";
import { useLocation } from "react-router-dom";
import Button from "../../../components/Button/Button";

export type ErrorType = "TECHNICAL_ERROR" | "FAILED_VERIFICATION_ERROR";

function ErrorMessageContent() {
  const { state } = useLocation();

  switch (state?.errorType as ErrorType) {
    case "FAILED_VERIFICATION_ERROR":
      return <ErrorMessage.FailedVerificationError />;
    case "TECHNICAL_ERROR":
    default:
      return <ErrorMessage.TechnicalError />;
  }
}

export default function PasswordResetRequestError() {
  return (
    <ErrorMessage
      title="Du hast dein Passwort vergessen?"
      link={
        <Button as={"a"} href={"/login"} width={"fullWidthMobile"}>
          Zurück zum Login
        </Button>
      }
    >
      <ErrorMessageContent />
    </ErrorMessage>
  );
}
